import { lazy, Suspense } from "react";

import { STRIPE_PRICE_PRO_MONTHLY } from "~/constants/stripe";

const SubscriptionModal = lazy(() => import("../SubscriptionModal"));

interface SubscriptionModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  returnPath: string;
  documentId?: string | null | undefined;
}

/**
 * Wrapper around SubscriptionModal that:
 * - Defaults the price to STRIPE_PRICE_PRO_MONTHLY
 * - Handles lazy loading with Suspense
 * - Simplifies the interface for common use cases
 */
const SubscriptionModalWrapper = ({
  isOpen,
  onClose,
  returnPath,
  documentId,
}: SubscriptionModalWrapperProps) => {
  return (
    <Suspense fallback={null}>
      <SubscriptionModal
        isOpen={isOpen}
        onClose={onClose}
        price={STRIPE_PRICE_PRO_MONTHLY}
        returnPath={returnPath}
        documentId={documentId}
      />
    </Suspense>
  );
};

export default SubscriptionModalWrapper;
